import { createStore } from 'vuex'
import router from '@/router'
import { getSettings } from '@/api/setting'

export default createStore({
  state: {
    // 存放状态
    token: localStorage.getItem('token') || '',
    userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
    systemSettings: {
      appName: '精灵名片',
      appLogo: ''
    }
  },
  getters: {
    // 计算属性
    isLoggedIn: state => !!state.token,
    appName: state => state.systemSettings.appName,
    appLogo: state => state.systemSettings.appLogo
  },
  mutations: {
    // 修改状态的方法
    SET_TOKEN (state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    SET_USER_INFO (state, userInfo) {
      state.userInfo = userInfo
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
    },
    SET_SYSTEM_SETTINGS (state, settings) {
      // 兼容 camelCase / snake_case / 旧键
      const appName = settings.systemName || settings.system_name || settings.appName || '精灵名片'
      const appLogo =
        settings.logoUrl || settings.logo_url || settings.system_logo || settings.appLogo || ''
      state.systemSettings.appName = appName
      state.systemSettings.appLogo = appLogo
    },
    CLEAR_USER_DATA (state) {
      state.token = ''
      state.userInfo = {}
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
    }
  },
  actions: {
    // 异步操作
    login ({ commit }, userData) {
      // 这里可以调用登录API
      return new Promise((resolve) => {
        // 模拟登录成功
        commit('SET_TOKEN', 'admin-token')
        commit('SET_USER_INFO', { username: userData.username })
        resolve()
      })
    },
    logout ({ commit }) {
      // 清除用户数据
      commit('CLEAR_USER_DATA')
      // 重定向到登录页
      router.push('/login')
    },
    async fetchSystemSettings ({ commit }) {
      try {
        const res = await getSettings()
        // 修复：请求封装返回的就是 response.data，这里不应再用 res.data
        const data = res
        let normalized = {}
        if (Array.isArray(data)) {
          // 旧格式：数组（若有多条，取最后一条或第一条，这里取第一条）
          const first = data[0] || {}
          normalized = {
            systemName: first.system_name || first.systemName || '精灵名片',
            logoUrl: first.logo_url || first.logoUrl || '',
            adminEmail: first.admin_email || first.adminEmail || ''
          }
        } else {
          // 新格式：对象
          const d = data || {}
          normalized = {
            systemName: d.systemName || d.system_name || '精灵名片',
            logoUrl: d.logoUrl || d.logo_url || '',
            adminEmail: d.adminEmail || d.admin_email || ''
          }
        }
        commit('SET_SYSTEM_SETTINGS', normalized)
      } catch (error) {
        console.error('获取系统设置失败:', error)
      }
    }
  },
  modules: {
    // 模块化
  }
})
